import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router'
import { GbDashboardAuthService } from '../gb-dashboard-auth-service/gb-dashboard-auth.service'

@Injectable({
  providedIn: 'root',
})
export class StaffSuGuard implements CanActivate {
  constructor(private gbDashboardAuthService: GbDashboardAuthService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.gbDashboardAuthService.isStaff()
  }
}
